import Slugify from "slugify";
import {z} from "zod";

/**
 * @todo Use a branded type
 */
export const Slug = z
    .string()
    .min(1)
    .regex(/^[a-z0-9-]+$/);
export type Slug = string;

/**
 * Globally configures slugify to include some additional necessary characters.
 */
Slugify.extend({
    "☢": "radioactive",
    "+": "plus",

    // To support names like 1.1pF
    ".": "p",
    ",": "c",

    // Electrical-related, overrides the greek ones
    μ: "u",
    Ω: "ohm",
});

/**
 * Slugifies a string
 *
 * Used to slugify the suffix of a project slug when we're making a unique one
 */
// eslint-disable-next-line no-restricted-syntax
export function slugify(str: string): string {
    return Slugify(str, {
        lower: true,
        strict: true,
    });
}

/**
 * Compute the slug for a given document name
 *
 * Note that it is NOT safe to use this function to produce a slug for a document based on its name from the frontend
 * e.g. during an import. That's because you cannot guarantee uniqueness for a given owner handle, not even by reading
 * all the documents under that owner handle (because there may be some the importing user cannot read). You must instead
 * use the backend to produce a valid slug.
 *
 * Instead:
 *  - On the backend, use the DocumentRenameService
 *  - On the frontend, use the getProjectName function on the FunctionsAdapter
 */
// eslint-disable-next-line no-restricted-syntax
export function slugifyDocumentName(name: Readonly<string>): Slug {
    return Slug.parse(slugify(name));
}
